// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fonts_bulkreprocess {
  font-size: 12px;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btn {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btn {
  background-color: #17a2b8;
  color: white;
  border: none;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -4% !important;
  margin-left: 3% !important;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 11%;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 18px;
}

.pipeline_label {
  float: left;
  padding-right: 5%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 75%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 76%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 75%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 75%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 75%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.transaction_feild {
  float: left;
  width: 76%;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 75%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 35px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 75%;
}

.btnsdiv {
  padding-left: 16%;
}

.startdate_label {
  float: left;
  position: relative;
}

.startdate_feild {
  float: left;
  width: 75%;
  padding-left: 5%;
}

.enddate_label {
  float: left;
  position: relative;
}

.enddate_feild {
  float: left;
  width: 100%;
}

.listlabelaligh {
  padding-inline: 2%;
  padding-top: 1%;
}

.badmsgcheckbox_label {
  float: left;
  position: relative;
}

.badmsgcheckbox_feild {
  float: right;
  padding-top: 1%;
  padding-right: 50%;
}

.messagetype_feild {
  width: 100%;
  height: 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  line-height: 10px;
}

.messagetype_feild_reason {
  width: 100%;
  height: 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  line-height: 20px;
}

.rightfixed {
  position: fixed;
  right: 0;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 67%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .transaction_feild {
    float: left;
    width: 64%;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 97%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 97%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 97%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 97%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 97%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .transaction_feild {
    float: left;
    width: 97%;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.routeName_class {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 77% !important;
  display: inline-block;
}

.notes_class {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-block: 2px;
  width: 31%;
  float: right;
  position: relative;
  left: 4%;
}

::ng-deep .mat-badge-medium .mat-badge-content {
  width: 16px !important;
  height: 16px !important;
  line-height: 18px !important;
}

::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {
  position: absolute;
  width: 170%;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

.btn_line_height {
  line-height: 30px !important;
}

.clickable-header {
  transition: background-color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  border-right: 1px solid;
  cursor: pointer;
}
.clickable-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.clickable-header:active {
  background-color: rgba(255, 255, 255, 0.2);
}
.clickable-header i {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  margin-left: 5px;
}
.clickable-header:hover i {
  opacity: 1;
}

.table-container-flex {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 210px);
}

.table-header-row {
  display: flex;
  flex-direction: unset;
  height: 30px;
  background-color: #17a0b4;
  color: white;
  flex-shrink: 0;
}

.table-data-scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

.table-data-row {
  display: flex;
  flex-direction: unset;
}

.page-size-footer {
  height: 30px;
  align-items: center;
  flex-shrink: 0;
}

.page-size-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}
.page-size-right span {
  font-size: 12px;
}
.page-size-right .page-size-label {
  margin-right: 10px;
}
.page-size-right .page-size-select {
  width: 80px;
  display: inline-block;
}

.record-count-text {
  font-size: 12px;
  color: #666;
}

::ng-deep .mat-mdc-tab-body-wrapper {
  display: block !important;
}`, "",{"version":3,"sources":["webpack://./src/app/metricpipelinelist/metricpipelinelist.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACE;EACI,YAAA;AAEN;;AAAI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAGN;;AADI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAIN;;AADI;EACE,0BAAA;EACA,0BAAA;AAIN;;AADI;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAIN;;AAFI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAKN;;AAHI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAMN;;AAJI;EACE,yBAAA;AAON;;AALI;EACE,yBAAA;AAQN;;AALI;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAQN;;AALI;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAQN;;AALI;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAQN;;AANI;EACE,8BAAA;AASN;;AAPI;EACE,8BAAA;AAUN;;AARI;EACE,mBAAA;AAWN;;AATI;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAYN;;AAVI;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAaN;;AAXI;EACE,8BAAA;AAcN;;AAXI;EACE,eAAA;EACA,eAAA;EACA,eAAA;AAcN;;AAXI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAcN;;AAZI;EACE,WAAA;EACA,UAAA;AAeN;;AAZI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAeN;;AAbI;EACE,WAAA;EACA,UAAA;AAgBN;;AAbI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAgBN;;AAdI;EACE,WAAA;EACA,UAAA;AAiBN;;AAdI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAiBN;;AAfI;EACE,WAAA;EACA,UAAA;AAkBN;;AAhBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAmBN;;AAjBI;EACE,WAAA;EACA,UAAA;AAoBN;;AAjBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAoBN;;AAlBI;EACE,WAAA;EACA,UAAA;AAqBN;;AAlBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAqBN;;AAlBI;EACE,UAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAqBN;;AAnBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAsBN;;AApBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAuBN;;AApBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAuBN;;AArBI;EACE,WAAA;EACA,UAAA;AAwBN;;AArBI;EACE,iBAAA;AAwBN;;AArBI;EACE,WAAA;EACA,kBAAA;AAwBN;;AAtBI;EACE,WAAA;EACA,UAAA;EACA,gBAAA;AAyBN;;AAtBI;EACE,WAAA;EACA,kBAAA;AAyBN;;AAvBI;EACE,WAAA;EACA,WAAA;AA0BN;;AAvBI;EACE,kBAAA;EACA,eAAA;AA0BN;;AAxBI;EACE,WAAA;EACA,kBAAA;AA2BN;;AAxBI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AA2BN;;AAzBI;EACE,WAAA;EACA,YAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AA4BN;;AA1BI;EACE,WAAA;EACA,YAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AA6BN;;AA3BI;EACE,eAAA;EACA,QAAA;AA8BN;;AA3BI;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA8BN;EA3BI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA6BN;EA3BI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EA6BN;EA3BI;IACE,WAAA;IACA,UAAA;EA6BN;EA1BI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA4BN;EAzBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA2BN;EAzBI;IACE,WAAA;IACA,UAAA;EA2BN;EAzBI;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EA2BN;EAzBI;IACE,0BAAA;EA2BN;EAzBI;IACE,cAAA;EA2BN;EAzBI;IACE,cAAA;EA2BN;EAxBM;IACE,qBAAA;EA0BR;AACF;AAtBI;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAwBN;EArBI;IACE,WAAA;IACA,UAAA;EAuBN;EArBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAuBN;EArBI;IACE,WAAA;IACA,UAAA;EAuBN;EArBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAuBN;EArBI;IACE,WAAA;IACA,UAAA;EAuBN;EArBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAuBN;EArBI;IACE,WAAA;IACA,UAAA;EAuBN;EApBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAsBN;EApBI;IACE,WAAA;IACA,UAAA;EAsBN;EApBI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAsBN;EApBI;IACE,WAAA;IACA,UAAA;EAsBN;EApBI;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAsBN;EAnBI;IACE,8BAAA;EAqBN;EAlBI;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAoBN;EAlBI;IACE,0BAAA;EAoBN;EAlBI;IACE,cAAA;EAoBN;EAlBI;IACE,cAAA;EAoBN;EAjBM;IACE,qBAAA;EAmBR;AACF;AAfI;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AAiBN;;AAdI;EACE,sBAAA;AAiBN;;AAdI;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAiBN;;AAbE;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAgBJ;;AAZE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAeJ;;AAZE;EACE,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAeJ;;AAXE;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;AAcJ;;AAXE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAcJ;;AAZE;EACI,4BAAA;AAeN;;AAXE;EACE,sCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,eAAA;AAcJ;AAZI;EACE,0CAAA;AAcN;AAXI;EACE,0CAAA;AAaN;AAVI;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAYN;AATI;EACE,UAAA;AAWN;;AANE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AASJ;;AALE;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AAQJ;;AAJE;EACE,gBAAA;EACA,kBAAA;EACA,OAAA;AAOJ;;AAHE;EACE,aAAA;EACA,qBAAA;AAMJ;;AAFE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AAKJ;;AADE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAIJ;AAFI;EACE,eAAA;AAIN;AADI;EACE,kBAAA;AAGN;AAAI;EACE,WAAA;EACA,qBAAA;AAEN;;AAGE;EACE,eAAA;EACA,WAAA;AAAJ;;AAIE;EACE,yBAAA;AADJ","sourcesContent":[".fonts_bulkreprocess{\r\n    font-size:12px;\r\n  }\r\n  .ng-autocompleteroutr {\r\n      width: 370px;\r\n    }\r\n    .search_btn {\r\n      background-color: #17a2b8;\r\n      color: white;\r\n      border: none;\r\n      outline: none;\r\n    }\r\n    .reset_btn {\r\n      background-color: #17a2b8;\r\n      color: white;\r\n      border: none;\r\n    }\r\n   \r\n    ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n      margin-top: -4% !important;\r\n      margin-left: 3% !important;\r\n      // padding-bottom: 10% !important;\r\n    }\r\n    .iconCheck {\r\n      font-size: 12px;\r\n      position: relative;\r\n      top: -20%;\r\n      margin-left: -3px;\r\n    }\r\n    .doller {\r\n      position: absolute;\r\n      top: -11px;\r\n      left: 15%;\r\n    }\r\n    .textCenter {\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n    }\r\n    .text-success {\r\n      color: #5dd077 !important;\r\n    }\r\n    .text-danger {\r\n      color: #da606c !important;\r\n    }\r\n  \r\n    .gui_ellipsis {\r\n      font-weight: 600;\r\n      width: 70%;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n  \r\n    .pipeline_ellipsis {\r\n      max-width: 89%;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      display: inline-block;\r\n      position: relative;\r\n      top: 8%;\r\n      left: 1%;\r\n      padding-right: 1%;\r\n    }\r\n  \r\n    .trans_ellipsis {\r\n      max-width: 74%;\r\n      white-space: nowrap;\r\n      display: inline-block;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      position: relative;\r\n      top: 11%;\r\n      padding-right: 1%;\r\n    }\r\n    .active_card {\r\n      border-left: 4px solid #07a36e;\r\n    }\r\n    .progress_card {\r\n      border-left: 4px solid #ffc107;\r\n    }\r\n    .iconPointer:hover {\r\n      pointer-events: all;\r\n    }\r\n    .arrow_source {\r\n      left: 5%;\r\n      width: 97%;\r\n      height: 2px;\r\n      background-color: grey;\r\n      position: relative;\r\n      top: 36%;\r\n    }\r\n    .arr_chev {\r\n      position: relative;\r\n      text-align: right !important;\r\n      right: -98%;\r\n      color: grey;\r\n      top: -9px;\r\n    }\r\n    .failed_card {\r\n      border-left: 4px solid #da606c;\r\n    }\r\n  \r\n    .copy_icon {\r\n      margin-left: 2%;\r\n      cursor: pointer;\r\n      font-size: 18px;\r\n    }\r\n  \r\n    .pipeline_label {\r\n      float: left;\r\n      padding-right: 5%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .pipeline_feild {\r\n      float: left;\r\n      width: 75%;\r\n    }\r\n  \r\n    .source_label {\r\n      float: left;\r\n      padding-right: 9%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .source_feild {\r\n      float: left;\r\n      width: 76%;\r\n    }\r\n  \r\n    .target_label {\r\n      float: left;\r\n      padding-right: 13%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .target_feild {\r\n      float: left;\r\n      width: 75%;\r\n    }\r\n  \r\n    .processor_label {\r\n      float: left;\r\n      padding-right: 7%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .processor_feild {\r\n      float: left;\r\n      width: 75%;\r\n    }\r\n    .message_label {\r\n      float: left;\r\n      padding-right: 9%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .message_feild {\r\n      float: left;\r\n      width: 75%;\r\n    }\r\n  \r\n    .transaction_label {\r\n      float: left;\r\n      padding-right: 3%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .transaction_feild {\r\n      float: left;\r\n      width: 76%;\r\n    }\r\n  \r\n    .message_type_label {\r\n      float: left;\r\n      padding-right: 3%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n  \r\n    .message_type_feild {\r\n      width: 75%;\r\n      box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n      border-radius: 5px;\r\n      padding-inline: 1%;\r\n      top: -6px;\r\n    }\r\n    .message_type_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .message_type {\r\n      width: 100%;\r\n      height: 35px;\r\n      position: relative;\r\n    }\r\n  \r\n    .messagefield_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .messagefield_feild {\r\n      float: left;\r\n      width: 75%;\r\n    }\r\n  \r\n    .btnsdiv {\r\n      padding-left: 16%;\r\n    }\r\n  \r\n    .startdate_label {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n    .startdate_feild {\r\n      float: left;\r\n      width: 75%;\r\n      padding-left: 5%;\r\n    }\r\n  \r\n    .enddate_label {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n    .enddate_feild {\r\n      float: left;\r\n      width: 100%;\r\n    }\r\n  \r\n    .listlabelaligh {\r\n      padding-inline: 2%;\r\n      padding-top: 1%;\r\n    }\r\n    .badmsgcheckbox_label {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n  \r\n    .badmsgcheckbox_feild {\r\n      float: right;\r\n      padding-top: 1%;\r\n      padding-right: 50%;\r\n    }\r\n    .messagetype_feild {\r\n      width: 100%;\r\n      height: 30px;\r\n      box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n      border-radius: 5px;\r\n      padding-inline: 1%;\r\n      padding-bottom: 1%;\r\n      line-height: 10px;\r\n    }\r\n    .messagetype_feild_reason {\r\n      width: 100%;\r\n      height: 30px;\r\n      box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n      border-radius: 5px;\r\n      padding-inline: 1%;\r\n      padding-bottom: 1%;\r\n      line-height: 20px;\r\n    }\r\n    .rightfixed {\r\n      position: fixed;\r\n      right: 0;\r\n    }\r\n  \r\n    @media screen and (min-width: 900px) and (max-width: 1024px) {\r\n      .pipeline_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n      }\r\n  \r\n      .target_label {\r\n        float: left;\r\n        padding-right: 9%;\r\n        position: relative;\r\n        top: 8px;\r\n      }\r\n      .processor_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n      }\r\n      .processor_feild {\r\n        float: left;\r\n        width: 67%;\r\n      }\r\n  \r\n      .message_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 8px;\r\n      }\r\n  \r\n      .transaction_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n      }\r\n      .transaction_feild {\r\n        float: left;\r\n        width: 64%;\r\n      }\r\n      .message_type {\r\n        width: 53%;\r\n        height: 35px;\r\n        position: relative;\r\n      }\r\n      .message_type_margin {\r\n        margin-left: 1% !important;\r\n      }\r\n      .pipeline_ellipsis {\r\n        max-width: 85%;\r\n      }\r\n      .trans_ellipsis {\r\n        max-width: 65%;\r\n      }\r\n      .message_btns {\r\n        span {\r\n          padding: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  \r\n    @media screen and (min-width: 500px) and (max-width: 786px) {\r\n      .pipeline_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 0px;\r\n      }\r\n  \r\n      .pipeline_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n      .source_label {\r\n        float: left;\r\n        padding-right: 6%;\r\n        position: relative;\r\n        top: 0px;\r\n      }\r\n      .source_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n      .target_label {\r\n        float: left;\r\n        padding-right: 9%;\r\n        position: relative;\r\n        top: 0px;\r\n      }\r\n      .target_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n      .processor_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 0px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n      }\r\n      .processor_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n  \r\n      .message_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 0px;\r\n      }\r\n      .message_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n      .transaction_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 0px;\r\n      }\r\n      .transaction_feild {\r\n        float: left;\r\n        width: 97%;\r\n      }\r\n      .message_type {\r\n        width: 86%;\r\n        height: 35px;\r\n        position: relative;\r\n      }\r\n  \r\n      .reset_btn {\r\n        padding-inline: 13% !important;\r\n      }\r\n  \r\n      .gui_ellipsis {\r\n        font-weight: 600;\r\n        width: 65%;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n      .message_type_margin {\r\n        margin-left: 1% !important;\r\n      }\r\n      .pipeline_ellipsis {\r\n        max-width: 81%;\r\n      }\r\n      .trans_ellipsis {\r\n        max-width: 52%;\r\n      }\r\n      .message_btns {\r\n        span {\r\n          padding: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .rightalign {\r\n      float: right;\r\n      padding-right: 60px;\r\n      padding-top: 10px;\r\n    }\r\n  \r\n    ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {\r\n      height: 0px !important;\r\n    }\r\n  \r\n    ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n      top: 0;\r\n      height: 0px !important;\r\n      overflow: hidden;\r\n    }\r\n  \r\n  \r\n  .date_control_style{\r\n    width: 100%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 2%;\r\n    // padding-block: 3%;\r\n  }\r\n  \r\n  .routeName_class{\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 77% !important;\r\n    display: inline-block;\r\n  }\r\n  \r\n  .notes_class{\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    padding-block: 2px;\r\n    width: 31%;\r\n    float: right;\r\n    position: relative;\r\n    left: 4%;\r\n  }\r\n  \r\n  \r\n  ::ng-deep .mat-badge-medium .mat-badge-content {\r\n    width: 16px !important;\r\n    height: 16px !important;\r\n    line-height: 18px !important;\r\n  }\r\n  \r\n  ::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {\r\n    position: absolute;\r\n    width: 170%;\r\n    background: #fff;\r\n    height: auto;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n    box-sizing: border-box;\r\n    font-size: 14px;\r\n  } \r\n  .btn_line_height{\r\n      line-height: 30px !important;\r\n  }\r\n\r\n  // Clickable header styles\r\n  .clickable-header {\r\n    transition: background-color 0.2s ease;\r\n    user-select: none;\r\n    border-right: 1px solid;\r\n    cursor: pointer;\r\n    \r\n    &:hover {\r\n      background-color: rgba(255, 255, 255, 0.1);\r\n    }\r\n    \r\n    &:active {\r\n      background-color: rgba(255, 255, 255, 0.2);\r\n    }\r\n    \r\n    i {\r\n      opacity: 0.7;\r\n      transition: opacity 0.2s ease;\r\n      margin-left: 5px;\r\n    }\r\n    \r\n    &:hover i {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  // Table container with flex layout\r\n  .table-container-flex {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: calc(100vh - 210px);\r\n  }\r\n\r\n  // Table header row\r\n  .table-header-row {\r\n    display: flex;\r\n    flex-direction: unset;\r\n    height: 30px;\r\n    background-color: #17a0b4;\r\n    color: white;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  // Scrollable data area\r\n  .table-data-scrollable {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    flex: 1;\r\n  }\r\n\r\n  // Data row\r\n  .table-data-row {\r\n    display: flex;\r\n    flex-direction: unset;\r\n  }\r\n\r\n  // Page size footer section\r\n  .page-size-footer {\r\n    height: 30px;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  // Page size right section with flex\r\n  .page-size-right {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 20px;\r\n\r\n    span {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .page-size-label {\r\n      margin-right: 10px;\r\n    }\r\n\r\n    .page-size-select {\r\n      width: 80px;\r\n      display: inline-block;\r\n    }\r\n  }\r\n\r\n  // Record count text\r\n  .record-count-text {\r\n    font-size: 12px;\r\n    color: #666;\r\n  }\r\n\r\n  // Fix scrollbar issue by overriding mat-mdc-tab-body-wrapper display:flex\r\n  ::ng-deep .mat-mdc-tab-body-wrapper {\r\n    display: block !important;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
